import React from 'react';
import { LightingServiceDetail } from '../components/christmas/LightingServiceDetail';
import { lightingCategories } from '../data/christmasLighting';
export function CommercialLighting() {
  const category = lightingCategories.find(c => c.slug === 'commercial');
  if (!category) return null;
  return <LightingServiceDetail category={category} data-id="element-451" data-mp="1k3u9n2329t8e" />;
}